import {
  SetStateAction,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import {
  LoadPrice,
  optionValue,
  OrderEvent,
  orderMsg,
  priceFailedMsg,
  PriceList,
} from '../../../labTests/models'
import { startSxpProxy } from '../../..//../utils/api'
import {
  CHAT_PROJECT_ID,
  OPD_PROJECT_ID,
  RADIOLOGY_PROJECT_ID,
} from '../../../../utils/constants'
import { toast } from 'react-toastify'
import ToastMessage from '../../../lms/components/ToastMessage'
import { toastOptions } from '../../../lms/models'
import {
  TotalPackagePrice,
  getDoctorForVisit,
  getPatientIdentifierById,
  saveRadiologyOrderFromLab,
  transformData,
  createOrUpdateInvoice,
} from '../../Utils/utils'
import KeycloakService from '../../../../utils/keycloakService'
import { RADIOLOGY_ORDERS_WRITE } from '../../../../utils/roles'
import { useAppDispatch, useAppSelector } from '../../../../app/hooks'
import {
  selectLocationById,
  selectSelectedLocationId,
} from '../../../location/locationSlice'
import Select from 'react-select'
import { Doctor } from '../../../scheduler/schedulerSlice'
import {
  fetchSlotsDoctorsAsync,
  selectSlotsDoctors,
} from '../../../slots/slotsSlice'
import { setQueryParam } from '../../../membership/membershipSlice'
import { Button, CircularProgress, IconButton } from '@mui/material'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import {
  setRadiologyDateFilter,
  setRadiologyActiveTab,
  setRadiologyShowBack,
  selectedRadiologyPatientCheck,
} from '../../RadiologySlice'
import DoneIcon from '@mui/icons-material/Done'
import {
  RadiologyLabTest,
  RadiologyOrders,
  selectedTest,
  RadiologyRow,
} from '../../models'
import { readableDateTimeFormat } from '../../../../utils/dateUtils'
import { useRadiologyOrganizations } from '../../useRadiologyOrganizations'
import {
  dialogMessages,
  emptyString,
  error,
  modeOptions,
  opdObj,
  originModes,
  originOptions,
  patientIdentifier,
  patientText,
  radiologyActions,
  radiologyButtons,
  radiologyIntents,
  radiologyModes,
  radiologyTestStatus,
  radiologyToastMessages,
  selectTests,
  success,
  tabs,
  testLabel,
  visit,
} from '../../Constants/constants'
import { Patient } from 'fhir/r4'
import { radiologyEndPoint } from '../../RadiologyEndPoints'
import CustomDialog from '../../dialogComponent/CustomDialogComponent'
import TestReplacementDialogContent from '../../dialogComponent/TestReplacementDialogContent'
import '../../../lms/lms.scss'
import { visits } from '../../../bedManagement/endpoints/EndPoints'
import './RadiologyOrder.scss'
import {
  fetchRadiologyTestPrice,
  getMasterEncounterByPatientId,
} from '../../../../services/RadiologyService'
import { IpdConstant } from '../../Constants/IpdRadiologyConstants'

const RadiologyOrder = ({
  patient,
  modeType,
  originMode,
}: {
  patient?: Patient
  modeType?: string
  originMode?: string
}) => {
  const { id }: any = useParams()
  const [loading, setLoading] = useState(false)
  const [submitButtonLoading, setSubmitButtonLoading] = useState(false)
  const [uhid, setUhid] = useState<string>('')
  const [newrowadded, setNewRowAdded] = useState(false)
  const [patientId, setPatientId] = useState<string>('')
  const [order, setOrder] = useState<RadiologyOrders>({})
  const [activeIndex, setActiveIndex] = useState(-1)
  const [orders, setOrders] = useState<RadiologyOrders[]>([])
  const [origin, setOrigin] = useState<string>('OPD')
  const locationId = useAppSelector(selectSelectedLocationId)
  const patientCheck = useAppSelector(selectedRadiologyPatientCheck)
  const location = useAppSelector((state) =>
    selectLocationById(locationId, state)
  )
  const [selectedTests, setSelectedTests] = useState<selectedTest[]>([])
  const [rows, setRows] = useState<RadiologyRow[]>([])
  const [ordersEvent, setOrdersEvent] = useState<OrderEvent[]>([])
  const [testAdded, setTestAdded] = useState<boolean>(false)
  const [lrNumber, setLrNumber] = useState('')
  const navigate = useNavigate()
  const [openDialog, setOpenDialog] = useState<boolean>(false)
  const [filteredTestsToReplace, setFilteredTestsToReplace] = useState<
    RadiologyRow[]
  >([])
  const [filteredTests, setFilteredTests] = useState<RadiologyRow[]>([])
  const [testNameOptions, setTestNameOptions] = useState<selectedTest[]>([])
  const organizations = useRadiologyOrganizations()
  const doctors = useAppSelector(selectSlotsDoctors)
  const VisitTableRef = useRef<HTMLDivElement | null>(null)
  const tableWrapperRef = useRef<HTMLDivElement | null>(null)
  const [priceLoading, setPriceLoading] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const [newRow, setNewRow] = useState<RadiologyRow>({
    mode: { label: 'Test', value: radiologyModes.test },
    requestedBy: null,
    sampleName: null,
    testName: null,
    origin: null,
    packageName: null,
    packageTests: null,
    price: 0,
    discount: 0,
  })
  const reqPatnerId = newRow?.requestedBy?.odooId
  const dispatch = useAppDispatch()
  const locations = useLocation()
  const requestedByOptions = useMemo(() => {
    return [
      { value: 'Self', label: 'Self' },
      ...(organizations?.map((org) => ({
        value: org?.name,
        label: org?.name,
      })) || []),
      ...(doctors?.map((d: Doctor) => {
        const doctorName = `Dr. ${d?.name}`
        const specialty = d?.specialty ? ` [${d?.specialty}]` : emptyString
        const displayName = `${doctorName}${specialty}`?.trim()
        return {
          value: displayName,
          label: displayName,
        }
      }) || []),
    ]
  }, [organizations, doctors])

  const selectedOrderOption = useMemo(() => {
    if (activeIndex === -1) return null
    return {
      value: activeIndex,
      label: `Order ${orders[activeIndex]?.id} - ${
        orders[activeIndex]?.source ?? ''
      } - ${orders[activeIndex]?.origin ?? ''}`,
    }
  }, [activeIndex, orders])

  const orderOptions = useMemo(() => {
    return orders?.map((ord, idx) => ({
      value: idx,
      label: `Order ${ord?.id} - ${ord?.source ?? ''} - ${ord?.origin ?? ''}`,
      title: `Order ${ord?.id} - ${readableDateTimeFormat(
        new Date(ord?.ordered_on ?? emptyString)
      )}`,
    }))
  }, [orders])

  const testNameOptionsWithDisabled = useMemo(() => {
    return testNameOptions?.map((option) => {
      const isTestDisabled = rows?.some(
        (row) =>
          (row?.testName && row?.testName?.value === option?.value) ||
          row?.packageTests?.radiology_lab_tests?.some(
            (test: any) => Number(test?.testId) === option?.value
          )
      )
      return {
        ...option,
        isDisabled: isTestDisabled,
      }
    })
  }, [testNameOptions, rows])

  useEffect(() => {
    if (locations?.pathname?.startsWith(radiologyEndPoint?.radiologyCreate)) {
      setNewRow((prevState) => ({
        ...prevState,
        origin: opdObj,
      }))
    }
  }, [locations?.pathname, setNewRow])
  const getAllRadiologyOrders = () => {
    setLoading(true)
    const intent = radiologyIntents?.getRadiologyOrdersByVisitId
    startSxpProxy(RADIOLOGY_PROJECT_ID, intent, { visitId: id })
      .then((data) => {
        const orders: RadiologyOrders[] = data?.data?.radiology_orders
        setOrders(orders)
        const state = { encounterId: id }
        startSxpProxy(OPD_PROJECT_ID, radiologyIntents?.getVisitApi, state)
          .then((data) => {
            const id = data?.data?.subject?.reference?.split('/')?.[1]
            setPatientId(data?.data?.subject?.reference?.split('/')?.[1])
            startSxpProxy(OPD_PROJECT_ID, radiologyIntents?.getPatientApi, {
              id,
            }).then((data) => {
              const uhid = data?.data?.identifier?.find(
                (e: any) => e?.sysytem === patientIdentifier
              )?.value
              setUhid(uhid)
            })
          })
          .catch(() => {
            if (modeType === visit && originMode === originModes?.ipd) {
              navigate(radiologyEndPoint?.bedAssignmentList)
            }
            if (modeType === visit && originMode === originModes?.opd) {
              navigate(radiologyEndPoint?.opd)
            }

            toast.error(
              <ToastMessage message={dialogMessages?.ipdRunTimeException} />
            )
          })
          .finally(() => setLoading(false))
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false))
  }
  const handleModeChange = (selectedOption: any) => {
    setNewRow((prev) => ({ ...prev, mode: selectedOption }))
  }
  const generateGlobalId = useCallback(() => {
    if (!order?.id) {
      startSxpProxy(
        CHAT_PROJECT_ID,
        radiologyIntents?.generateGlobalId,
        {}
      ).then((data) => {
        setLrNumber(data?.data?.id)
      })
    }
  }, [order])

  const executeFunction = () => {
    const state = {}
    startSxpProxy(
      RADIOLOGY_PROJECT_ID,
      radiologyIntents?.getRadiologyTestsAPI,
      state
    )
      .then((data) => {
        const panelData = data?.data?.radiology_lab_test ?? []
        const tests = panelData?.map((test: any) => ({
          label: test?.name,
          value: test?.id,
          sampleId: test?.sample_id,
          sampleName: test?.radiology_sample?.name,
          odoo_test_id: test?.odoo_test_id,
        }))
        const selectedTestLabels = rows?.map((row) => row?.testName?.label)
        const filteredTests = tests?.filter(
          (test: any) => !selectedTestLabels.includes(test?.label)
        )
        setTestNameOptions(filteredTests)
      })
      .catch((error) => {
        console.error('Error fetching test names:', error)
        setTestNameOptions([])
      })
  }
  const handleTestNameChange = async (selectedOption: any) => {
    if (!selectedOption) return

    const updatedRow: any = {
      testName: {
        label: selectedOption?.label,
        value: selectedOption?.value,
        odoo_test_id: selectedOption?.odoo_test_id,
      },
      sampleName: {
        label: selectedOption?.sampleName,
        value: selectedOption?.sampleId,
      },
    }

    const priceList = location?.resource?.type?.[0]?.coding?.find(
      (item: any) => item.code === PriceList
    )?.display

    setPriceLoading(true)
    const b2bOrigin = origin === optionValue?.b2b?.value
    const reqDoctorRef = newRow?.requestedBy?.doctorRef

    const result = await fetchRadiologyTestPrice({
      locationResourceId: location?.resource?.id,
      patientId: id,
      odooTestId: selectedOption?.odoo_test_id,
      priceList,
      b2bOrigin,
      reqPatnerId,
      reqDoctorRef,
    })

    setPriceLoading(false)

    if (result.success && result.data) {
      const { price, defaultPrice, pricelistId, discount } = result.data
      updatedRow.price = price
      updatedRow.discount = discount
      updatedRow.defaultPrice = defaultPrice
      updatedRow.panel = {
        ...updatedRow.testName,
        price,
        discount,
        defaultPrice,
        pricelist_id: pricelistId,
        best_price: price,
      }
      setNewRow((prev) => ({ ...prev, ...updatedRow }))
    } else {
      const errorMsg = result.error || priceFailedMsg
      toast(<ToastMessage message={errorMsg} />, {
        ...toastOptions,
        type: error,
      })
      setNewRow((prev) => ({ ...prev, ...updatedRow }))
    }
  }

  // Helper functions for handleSave - extracted for better code organization
  const createTestPanel = (row: RadiologyRow) => ({
    sampleName: row?.sampleName?.label,
    sampleId: row?.sampleName?.value,
    testName: row?.testName?.label,
    testId: row?.testName?.value,
    isTestSelect: true,
    packageId: null,
    price: row?.price || null,
    discount: row?.discount || null,
    defaultPrice: row?.defaultPrice || null,
  })

  const addPackageTestToResult = (
    test: RadiologyLabTest,
    packageId: number,
    result: any[]
  ) => {
    const existingTest = result?.find(
      (item) => Number(item?.testId) === Number(test?.testId)
    )
    if (existingTest) {
      existingTest.packageId?.push(packageId)
    } else {
      result.push({
        testId: Number(test?.testId),
        sampleId: test?.sampleId,
        testName: test?.testName,
        sampleName: test?.sampleName,
        isTestSelect: false,
        packageId: [packageId],
      })
    }
  }

  const processPackageRows = (rows: RadiologyRow[]) => {
    const result: any[] = []
    rows
      ?.filter((row) => row?.mode?.value === radiologyModes?.package)
      ?.forEach((row) => {
        const packageId = row?.packageTests?.packageId
        if (packageId === undefined) {
          return
        }
        row?.packageTests?.radiology_lab_tests?.forEach(
          (test: RadiologyLabTest) => {
            addPackageTestToResult(test, packageId, result)
          }
        )
      })
    return result
  }

  /**
   * Extracts product ID from a row, checking multiple possible locations
   */
  const extractProductId = (
    row: any,
    order: RadiologyOrders
  ): number | null => {
    return (
      row?.panel?.odoo_test_id ||
      row?.OdooPackageId ||
      order?.package_id ||
      row?.testName?.odoo_test_id ||
      null
    )
  }

  /**
   * Extracts product information from a row
   */
  const extractProductInfo = (row: any, order: RadiologyOrders) => ({
    product_id: extractProductId(row, order),
    price:
      row?.defaultPrice || row?.panel?.defaultPrice || row?.packagePrice || 0,
    discount_percent: row?.panel?.discount || row?.discount,
  })

  /**
   * Filters out invalid products (null or undefined product_id)
   */
  const isValidProduct = (product: any): boolean => {
    return product?.product_id !== null && product?.product_id !== undefined
  }

  /**
   * Creates a B2B product entry
   */
  const createB2BProduct = (
    productId: number,
    price: number,
    discountPercent: any,
    orderRefId: any
  ) => ({
    product_id: productId,
    product_uom_qty: 1,
    order_ref: orderRefId,
    patient_id: productId,
    price,
    discount_percent: discountPercent,
  })

  /**
   * Creates a standard product entry
   */
  const createStandardProduct = (
    productId: number,
    price: number,
    discountPercent: any
  ) => ({
    product_id: productId,
    quantity: 1,
    price,
    discount_percent: discountPercent,
  })

  /**
   * Aggregates products, combining duplicates by incrementing quantity
   */
  const aggregateProducts = (
    products: Array<{
      product_id: number
      price: number
      discount_percent: any
    }>,
    isB2BOrigin: boolean,
    orderRefId: any
  ) => {
    return products.reduce((accumulator: any[], item) => {
      const existingProduct = accumulator.find(
        (entry) => entry.product_id === item.product_id
      )

      if (existingProduct) {
        // Increment quantity for existing product
        if (isB2BOrigin) {
          existingProduct.product_uom_qty += 1
        } else {
          existingProduct.quantity += 1
        }
      } else {
        // Add new product
        const newProduct = isB2BOrigin
          ? createB2BProduct(
              item.product_id,
              item.price,
              item.discount_percent,
              orderRefId
            )
          : createStandardProduct(
              item.product_id,
              item.price,
              item.discount_percent
            )
        accumulator.push(newProduct)
      }

      return accumulator
    }, [])
  }

  /**
   * Builds the Odoo product list from rows, handling both B2B and standard orders
   */
  const buildOdooProductList = (
    rows: RadiologyRow[],
    order: RadiologyOrders
  ) => {
    // Extract product information from all rows
    const productInfoList = rows
      .map((row: any) => extractProductInfo(row, order))
      .filter(isValidProduct)
      .filter(
        (
          product
        ): product is {
          product_id: number
          price: number
          discount_percent: any
        } => product?.product_id !== null
      )

    // Determine if this is a B2B origin
    const isB2BOrigin = order?.origin === optionValue?.b2b?.value

    // Aggregate products and return
    return aggregateProducts(productInfoList, isB2BOrigin, order?.ref_id)
  }

  /**
   * Determines the navigation route based on order parameters
   */
  const determineNavigationRoute = (
    origin: string,
    modeType: string | undefined,
    originMode: string | undefined
  ): 'visit' | 'b2b' | 'opd' | 'ipd' | 'none' => {
    // Visit mode takes highest priority
    switch (modeType) {
      case visit:
        return 'visit'
    }

    // Check origin type
    switch (origin) {
      case optionValue?.b2b?.value:
        return 'b2b'

      case optionValue?.origin?.value:
        return 'opd'

      case optionValue?.ipd?.value:
        return 'ipd'
    }

    // Check origin mode for non-visit cases
    switch (originMode) {
      case originModes?.opd:
        return modeType !== visit ? 'opd' : 'none'

      case originModes?.ipd:
        return modeType !== visit ? 'ipd' : 'none'

      default:
        return 'none'
    }
  }

  /**
   * Handles post-order success operations including navigation and state updates
   */
  const handleOrderSuccess = (
    data: {
      data: { insert_radiology_orders_one: SetStateAction<RadiologyOrders> }
    },
    origin: string,
    modeType: string | undefined,
    originMode: string | undefined
  ) => {
    // Update order state and show success message
    setOrder(data?.data?.insert_radiology_orders_one)
    toast(
      <ToastMessage
        message={
          order?.id
            ? dialogMessages?.modifedRadiologyOrder
            : dialogMessages?.createRadiologyOrder
        }
      />,
      { ...toastOptions, type: success }
    )
    setSubmitButtonLoading(false)

    // Determine navigation route
    const route = determineNavigationRoute(origin, modeType, originMode)
    // Handle navigation based on route
    switch (route) {
      case 'visit':
        setActiveIndex(-1)
        setRows([])
        getAllRadiologyOrders()
        return

      case 'b2b':
        navigate(radiologyEndPoint?.orderInvoice)
        break

      case 'opd':
        dispatch(setRadiologyActiveTab(tabs?.testing))
        navigate(radiologyEndPoint?.orderInvoice)
        break

      case 'ipd':
        dispatch(setRadiologyActiveTab(tabs?.testing))
        navigate(radiologyEndPoint?.radiologyDashboard)
        break

      case 'none':
      default:
        // No specific navigation
        break
    }

    // Update date filter for all non-visit cases
    dispatch(setRadiologyDateFilter(new Date()?.toISOString()?.slice(0, 10)))
  }

  const handleSave = async () => {
    if (!KeycloakService?.hasRole([RADIOLOGY_ORDERS_WRITE])) return

    if (!rows?.length) {
      toast(<ToastMessage message={dialogMessages?.addOneTest} />, {
        ...toastOptions,
        type: error,
      })
      return
    }

    setSubmitButtonLoading(true)

    // Process test panels
    const filteredPanels = rows
      ?.filter((row) => row?.mode?.value === radiologyModes?.test)
      ?.map(createTestPanel)

    // Process package tests
    const packageResult = processPackageRows(rows)
    const packageIds = [
      ...new Set(
        packageResult?.flatMap((item) => item?.packageId)?.filter(Boolean)
      ),
    ]
    const combinedResult = [...filteredPanels, ...packageResult]

    // Prepare order metadata
    const mode: 'visit' | 'patient' = modeType === visit ? visit : patientText
    const locationName = location?.resource?.name || emptyString
    const price = TotalPackagePrice(rows) ?? 0
    const doctorName = await getDoctorForVisit(id ?? '')
    const requestedBy = locations?.pathname?.startsWith(visits)
      ? doctorName
      : rows?.[rows?.length - 1]?.requestedBy?.value
    const reqOdooId = rows?.[rows?.length - 1]?.requestedBy?.odooId
    const reqDoctorRef = rows?.[rows?.length - 1]?.requestedBy?.doctorRef

    // Build Odoo test IDs
    const updatedTestIds = buildOdooProductList(rows, order)

    try {
      let invoiceResponse = null

      // Handle invoice creation for radiology search path
      if (
        locations?.pathname.startsWith(radiologyEndPoint?.radiologySearch) &&
        origin !== optionValue?.others?.value &&
        origin !== optionValue?.ipd?.value
      ) {
        invoiceResponse = await createOrUpdateInvoice(
          origin,
          updatedTestIds,
          order,
          uhid,
          reqOdooId,
          reqDoctorRef,
          rows,
          locationId,
          setSubmitButtonLoading
        )

        if (
          !invoiceResponse ||
          invoiceResponse?.data?.odooApistatus === error
        ) {
          return
        }
      }

      // Validate invoice response
      const response = invoiceResponse?.data
      if (response?.odooApistatus === error) {
        toast(
          <ToastMessage message={response?.message || orderMsg?.failedmsg} />,
          { ...toastOptions, type: error }
        )
        setIsSaving(false)
        setSubmitButtonLoading(false)
        return
      }

      // Extract invoice IDs
      const odooInvoiceID = invoiceResponse?.data?.odoo_invoice_id || null
      const RefID = invoiceResponse?.data?.ref_id || null
      // Save radiology order
      const data = await saveRadiologyOrderFromLab(
        mode,
        activeIndex !== -1 ? order : undefined,
        id,
        patientId,
        uhid,
        lrNumber,
        combinedResult,
        [],
        locationName,
        rows?.[0]?.packageTests?.packageId ?? 0,
        price,
        requestedBy,
        origin,
        packageIds,
        combinedResult,
        odooInvoiceID,
        RefID,
        locationId
      )

      handleOrderSuccess(data, origin, modeType, originMode)
    } catch (err) {
      setSubmitButtonLoading(false)
      console.log(err, 'err')
      setRows([])
    } finally {
      setIsSaving(false)
    }
  }

  const handleActiveOrderChage = (
    orders: RadiologyOrders[],
    index?: number
  ) => {
    const currentIndex = index !== undefined ? index : activeIndex
    let activeOrder: any = {}
    if (currentIndex === -1) {
      // New order
      activeOrder = {}
    } else {
      activeOrder = orders[currentIndex] ?? {}
    }

    setOrder(activeOrder)
    const formattedRows: RadiologyRow[] = activeOrder?.id
      ? transformData(activeOrder)
      : []
    const firstRow = formattedRows?.[0]
    setRows(formattedRows || [])
    setOrdersEvent(activeOrder?.order_events ?? [])

    if (
      activeOrder?.id &&
      activeOrder?.radiology_order_tests &&
      activeOrder?.radiology_order_tests.length >= 1
    ) {
      setNewRow({
        mode: firstRow?.mode || {
          label: testLabel,
          value: radiologyModes?.test,
        },
        requestedBy: firstRow?.requestedBy ?? null,
        sampleName: null,
        testName: null,
        origin: firstRow?.origin ?? null,
        packageName: null,
        packageTests: null,
      })
    } else {
      setNewRow({
        mode: {
          label: testLabel,
          value: radiologyModes?.test,
        },
        requestedBy: null,
        sampleName: null,
        testName: null,
        origin: null,
        packageName: null,
        packageTests: null,
      })
    }
  }
  const fetchData = async () => {
    setLoading(true)
    try {
      const radiologyOrderData = await startSxpProxy(
        RADIOLOGY_PROJECT_ID,
        radiologyIntents?.getRadiologyOrdersForPatientForOpd,
        { patientId: id }
      )
      const orders: RadiologyOrders[] =
        radiologyOrderData?.data?.radiology_orders ?? []
      setOrders(orders)
      handleActiveOrderChage(orders)
    } catch (err) {
      setLoading(false)
      console.error(err)
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    if (modeType === visit) {
      getAllRadiologyOrders()
    } else if (id && modeType === patientText) {
      fetchData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patient, modeType])
  const handleSaveRow = () => {
    switch (true) {
      case newRow?.mode?.value === radiologyModes?.test && !newRow.sampleName:
        toast.warn(dialogMessages?.selectSample)
        break

      case newRow?.mode?.value === radiologyModes?.test && !newRow.testName:
        toast.warn(dialogMessages?.selectTest)
        break

      case newRow?.mode?.value === radiologyModes?.package &&
        !newRow.packageName:
        toast.warn(dialogMessages?.selectPackage)
        break

      case locations.pathname.startsWith(radiologyEndPoint?.radiologyCreate) &&
        !newRow.requestedBy:
        toast.warn(dialogMessages?.selectRequestedBy)
        break

      case !newRow.mode:
        toast.warn(dialogMessages?.selectMode)
        break

      default:
        if (
          rows?.length > 0 &&
          newRow?.mode?.value === radiologyModes?.package
        ) {
          const selectedPackageTest = newRow?.packageTests?.radiology_lab_tests
            ?.map((e: any) => e?.testId)
            .map((n: any) => Number(n))

          const filteredRows = rows?.filter((e: any) => e?.testName)
          const filtered = filteredRows?.filter(
            (obj: any) => !selectedPackageTest?.includes(obj?.testName?.value)
          )
          setFilteredTestsToReplace(filtered)

          const unFiltered = filteredRows?.filter(
            (obj: any) =>
              selectedPackageTest?.includes(obj?.testName?.value) ?? false
          )
          setFilteredTests(unFiltered)

          if (unFiltered?.length > 0) {
            setOpenDialog(true)
          } else {
            addRowToTable(filtered)
          }
        } else {
          addRowToTable([])
        }
        break
    }
  }
  const addRowToTable = (filtered: any[]) => {
    if (rows?.length > 0 && newRow?.mode?.value === radiologyModes?.package) {
      const filteredPackageTests = rows?.filter((e: any) => e?.packageTests)
      if (filteredPackageTests?.length > 0) {
        setRows([...filtered, ...filteredPackageTests, newRow])
      } else {
        setRows([...filtered, newRow])
      }
    } else {
      setRows((prevRows) => [...prevRows, newRow])
    }

    const nextRow = {
      mode: newRow?.mode,
      requestedBy: newRow?.requestedBy,
      origin: newRow?.origin,
      sampleName: null,
      testName: null,
      packageTests: null,
      packageName: null,
    }
    setNewRow(nextRow)
    setNewRowAdded(true)

    if (newRow?.testName) {
      setSelectedTests([...selectedTests, newRow?.testName])
    }

    setTestAdded((prev) => !prev)
  }
  const handleConfirmReplace = () => {
    setOpenDialog(false)
    addRowToTable(filteredTestsToReplace)
  }

  const handleRequestedByChange = (selectedOption: any) => {
    setNewRow((prev) => ({ ...prev, requestedBy: selectedOption }))
  }

  const handleOriginChange = async (selectedOption: any) => {
    const selectedValue = selectedOption?.value || emptyString
    if (modeType === patientText && selectedValue === IpdConstant) {
      const response = await getMasterEncounterByPatientId(patient?.id || '')
      if (response?.success) {
        if (response?.data?.entry) {
          toast.warn(radiologyToastMessages?.redirectIpdDasboard)
          return
        } else {
          setOrigin(selectedValue)
          setNewRow((prev) => ({ ...prev, origin: selectedOption }))
        }
      } else {
        toast.error(radiologyToastMessages?.checkingIpdEncounterError)
        return
      }
    } else {
      setOrigin(selectedValue)
      setNewRow((prev) => ({ ...prev, origin: selectedOption }))
    }
  }
  const handleDeleteRow = (index: number) => {
    setRows((prevRows: RadiologyRow[]) => {
      const updatedRows = [...prevRows]
      updatedRows.splice(index, 1)
      return updatedRows
    })
    setNewRowAdded(true)
  }
  const isPointerEventsDisabled = ordersEvent?.some((event) =>
    event.tests?.some(
      (test) =>
        test.status !== radiologyTestStatus?.orderModified &&
        test.status !== radiologyTestStatus?.ordered
    )
  )
  const renderParameters = (parameters: any) => {
    return (
      <div>
        {parameters?.map((item: any) => {
          return <li key={item?.testId}>{item?.testName}</li>
        })}
      </div>
    )
  }
  const handleCloseDialog = () => {
    setOpenDialog(false)
  }
  const handleCancelReplace = () => {
    setOpenDialog(false) // Close the dialog, do nothing
  }
  const checkOrderStatus = (order: RadiologyOrders) => {
    return order?.radiology_order_tests?.every(
      (test: any) =>
        test?.test_status === radiologyTestStatus?.orderModified ||
        test?.test_status === radiologyTestStatus?.ordered ||
        test?.test_status === radiologyTestStatus?.reOrdered ||
        test?.test_status === radiologyTestStatus?.deleted
    )
  }
  const handleIndexChange = (index: any) => {
    setActiveIndex(index)
    setNewRowAdded(false)
    setOrder({})
    handleActiveOrderChage(orders, index)
  }
  useEffect(() => {
    dispatch(fetchSlotsDoctorsAsync())
  }, [dispatch])
  useEffect(() => {
    const resizeHandler = () => {
      const container = VisitTableRef.current
      const tableWrapper = tableWrapperRef.current
      if (container) {
        const availableHeight =
          window.innerHeight - container.getBoundingClientRect().top
        container.style.maxHeight = `${availableHeight - 90}px`
      }
      if (tableWrapper) {
        const availableHeight =
          window.innerHeight - tableWrapper.getBoundingClientRect().top
        tableWrapper.style.maxHeight = `${availableHeight - 150}px`
      }
    }
    window.addEventListener('resize', resizeHandler)
    resizeHandler()
    return () => {
      window.removeEventListener('resize', resizeHandler)
      dispatch(setQueryParam({ q: '', param: '' }))
    }
  }, [dispatch])

  useEffect(() => {
    executeFunction()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testAdded])

  useEffect(() => {
    generateGlobalId()
  }, [generateGlobalId])
  useEffect(() => {
    const radiologyAction =
      !patientCheck || (patientCheck && rows?.length === 0)
        ? radiologyActions?.create
        : radiologyActions?.delete
    dispatch(setRadiologyShowBack(radiologyAction))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rows, patientCheck])

  useEffect(() => {
    if (patient) {
      setUhid(getPatientIdentifierById(patient))
    }
    if (modeType) {
      if (modeType === visit && originMode === originModes?.ipd) {
        setOrigin(originMode)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patient, modeType])
  const handleOrderIndexChange = (option: any) => {
    if (option) {
      handleIndexChange(option.value)
    }
  }
  const isEditingOrder = activeIndex !== -1
  return (
    <>
      <CustomDialog
        open={openDialog}
        title={dialogMessages?.testListToBeRemoved}
        content={
          <TestReplacementDialogContent
            dialogMessages={dialogMessages}
            filteredTests={filteredTests}
          />
        }
        onClose={handleCloseDialog}
        onConfirm={handleConfirmReplace}
        onCancel={handleCancelReplace}
        primaryButtonText={radiologyButtons?.proceed}
        secondaryButtonText={radiologyButtons?.cancel}
      />
      <div className='radiology-order-container'>
        <div className='order-buttons-wrapper'>
          <div className='order-buttons-wrap'>
            <div className='order-select-container'>
              <Select
                classNamePrefix='react-select'
                className='order-select'
                value={selectedOrderOption}
                onChange={(option: any) => handleOrderIndexChange(option)}
                options={orderOptions}
                placeholder='Select an existing order'
                isClearable
                menuPortalTarget={document.body}
                menuPosition='fixed'
                classNames={{
                  menuPortal: () => 'react-select__menu-portal',
                  menu: () => 'react-select__menu',
                  menuList: () => 'react-select__menu-list',
                  option: () => 'react-select__option',
                  singleValue: () => 'react-select__single-value',
                }}
              />
            </div>
            <button
              className={`order-btn new-order ${
                activeIndex === -1 ? 'active' : ''
              }`}
              onClick={() => handleIndexChange(-1)}
            >
              <span className='order-btn-text'>New Order</span>
            </button>
          </div>
          <div className='order-submit-button'>
            <Button
              onClick={handleSave}
              disabled={
                !newrowadded ||
                isSaving ||
                (modeType === visit &&
                  activeIndex !== -1 &&
                  !checkOrderStatus(order)) ||
                rows?.length === 0 ||
                submitButtonLoading
              }
              size='medium'
              variant='contained'
              className='submit-button'
            >
              {isSaving ? 'Saving...' : 'Submit'}
            </Button>
          </div>
        </div>
        <div className='radiology-order-table'>
          {loading ? (
            <div className='save-action'>
              <CircularProgress className='circular-progress-action' />
              <span>{dialogMessages?.checkPreviousTests}</span>
            </div>
          ) : (
            <div
              className={
                isPointerEventsDisabled
                  ? 'pointer-events-none'
                  : 'pointer-events-auto'
              }
            >
              <div ref={tableWrapperRef} className='table-wrapper'>
                <table className='radiology-data-table'>
                  <thead>
                    <tr>
                      <th className='col-sl-no'>Sl.No</th>
                      <th className='col-date'>Date</th>
                      <th className='col-mode'>Mode</th>
                      <th className='col-origin'>Service</th>
                      <th className='col-requested-by'>Requested By</th>
                      <th className='col-test-name'>
                        {newRow?.mode?.value === radiologyModes?.package
                          ? selectTests
                          : 'Name'}
                      </th>
                      <th className='col-quantity text-center'>Quantity</th>
                      <th className='col-price price-cell'>Price</th>
                      <th className='col-discount price-cell'>Discount</th>
                      <th className='col-subtotal price-cell'>Subtotal</th>
                      <th className='col-action text-center'>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className='new-row pointer-events-auto'>
                      <td className='text-center'>-</td>
                      <td className='text-center'>
                        {new Date().toLocaleDateString()}
                      </td>

                      <td>
                        <Select
                          value={newRow?.mode || ''}
                          onChange={handleModeChange}
                          options={modeOptions}
                          isDisabled={isEditingOrder}
                          classNamePrefix='react-select'
                          className='lms-custom-select'
                          menuPortalTarget={document.body}
                          menuPosition='fixed'
                          classNames={{
                            menuPortal: () => 'lms-custom-select-portal',
                            menu: () => 'lms-custom-select-menu',
                            menuList: () => 'lms-custom-select-menu-list',
                            option: () => 'lms-custom-select-option',
                            singleValue: () => 'lms-custom-select-single-value',
                          }}
                        />
                      </td>
                      <td>
                        <Select
                          isClearable
                          value={newRow?.origin}
                          onChange={handleOriginChange}
                          isDisabled={isEditingOrder}
                          classNamePrefix='react-select'
                          options={originOptions}
                          className='lms-custom-select'
                          menuPortalTarget={document.body}
                          menuPosition='fixed'
                          classNames={{
                            menuPortal: () => 'lms-custom-select-portal',
                            menu: () => 'lms-custom-select-menu',
                            menuList: () => 'lms-custom-select-menu-list',
                            option: () => 'lms-custom-select-option',
                            singleValue: () => 'lms-custom-select-single-value',
                          }}
                        />
                      </td>
                      <td>
                        <Select
                          placeholder='Select Requested By'
                          className='react-select-container react-select-control'
                          classNamePrefix='react-select'
                          isClearable
                          value={newRow?.requestedBy || ''}
                          isDisabled={isEditingOrder}
                          onChange={handleRequestedByChange}
                          options={requestedByOptions}
                          menuPortalTarget={document.body}
                          classNames={{
                            menuPortal: () => 'react-select__menu-portal',
                            menu: () => 'react-select__menu',
                            menuList: () => 'react-select__menu-list',
                            option: () => 'react-select__option',
                            singleValue: () => 'react-select__single-value',
                          }}
                        />
                      </td>
                      <td>
                        <Select
                          classNamePrefix='react-select'
                          options={testNameOptionsWithDisabled}
                          value={newRow?.testName}
                          onChange={handleTestNameChange}
                          placeholder='Select Test Name'
                          formatOptionLabel={(option: any) => (
                            <div className='select-test'>
                              <span>{option?.label}</span>
                              <span>
                                {option?.isDisabled && (
                                  <DoneIcon className='disabled-action' />
                                )}
                              </span>
                            </div>
                          )}
                          isOptionDisabled={(option: any) => option?.isDisabled}
                          className='lms-custom-select'
                          menuPortalTarget={document.body}
                          menuPosition='fixed'
                          classNames={{
                            menuPortal: () => 'lms-custom-select-portal',
                            menu: () => 'lms-custom-select-menu',
                            menuList: () => 'lms-custom-select-menu-list',
                            option: () => 'lms-custom-select-option',
                            singleValue: () => 'lms-custom-select-single-value',
                          }}
                        />
                      </td>
                      <td className='text-center'>1</td>
                      <td className='price-cell'>
                        {priceLoading ? (
                          <span className='loader'>{LoadPrice}</span>
                        ) : (
                          <span>
                            ₹ {newRow?.defaultPrice?.toFixed(2) || '0.00'}
                          </span>
                        )}
                      </td>
                      <td className='price-cell'>
                        {newRow?.discount?.toFixed(2) || '0.00'}%
                      </td>
                      <td className='price-cell'>
                        ₹ {newRow?.price?.toFixed(2) || '0.00'}
                      </td>
                      {newRow?.mode?.value === radiologyModes?.package && (
                        <td>
                          {renderParameters(
                            newRow?.packageTests?.radiology_lab_tests
                          )}
                        </td>
                      )}
                      <td className='text-center'>
                        <Button
                          onClick={handleSaveRow}
                          disabled={
                            modeType === visit &&
                            activeIndex !== -1 &&
                            !checkOrderStatus(order)
                          }
                          size='small'
                          variant='contained'
                          className='add-button'
                        >
                          Add
                        </Button>
                      </td>
                    </tr>
                    {rows?.map((row, index) => (
                      <tr key={index}>
                        <td className='text-center'>{index + 1}</td>

                        <td className='text-center'>
                          {new Date().toLocaleDateString()}
                        </td>

                        <td>{row?.mode?.label}</td>
                        <td>{row?.origin?.label}</td>
                        <td>{row?.requestedBy?.label}</td>
                        <td>
                          {row?.mode?.value === radiologyModes?.package
                            ? row?.packageName?.label
                            : row?.testName?.label}
                        </td>
                        <td className='text-center'>1</td>
                        <td className='price-cell'>
                          ₹{row?.defaultPrice?.toFixed(2) ?? '0.00'}
                        </td>
                        <td className='price-cell'>
                          {row?.discount?.toFixed(2) ?? '0.00'}%
                        </td>
                        <td className='price-cell'>
                          ₹ {row?.price?.toFixed(2) ?? '0.00'}
                        </td>
                        {row?.mode?.value === radiologyModes?.package && (
                          <td>
                            {renderParameters(
                              row?.packageTests?.radiology_lab_tests
                            )}
                          </td>
                        )}
                        <td className='text-center'>
                          <IconButton
                            size='small'
                            onClick={() => handleDeleteRow(index)}
                            disabled={
                              modeType === visit &&
                              activeIndex !== -1 &&
                              !checkOrderStatus(order)
                            }
                            className='delete-icon'
                          >
                            <DeleteOutlinedIcon fontSize='small' />
                          </IconButton>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          <div className='order-submit-button total-price-container'>
            <div className='total-info'>
              <div className='info-box'>
                <span className='test-label'>Total Tests:</span>
                <span className='value'>{rows?.length}</span>
              </div>
              <div className='info-box'>
                <span className='test-label'>Amount:</span>
                <span className='value amount'>
                  ₹ {TotalPackagePrice(rows)?.toFixed(2) || '0.00'}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default RadiologyOrder
